import { Injectable } from '@angular/core';
import { ToastOptions, ToastsManager } from 'ng2-toastr';

@Injectable()
export class ToastService {

  constructor(
    public toastr: ToastsManager,
    public toastrOptions: ToastOptions
  ) {
    this.toastrOptions.toastLife = 5000;
    this.toastrOptions.showCloseButton = true;
  }

  public update(msg: string, title?: string): void {
    if (msg && typeof msg === 'string' && msg.length > 0) {
      const _title = (title && typeof title === 'string' && title.length > 0) ? title : null;
      this.toastr.info(msg, _title).then();
    }
  }

  public success(msg: string, title?: string): void {
    if (msg && typeof msg === 'string' && msg.length > 0) {
      const _title = (title && typeof title === 'string' && title.length > 0) ? title : null;
      this.toastr.success(msg, _title).then();
    }
  }

  public error(msg: string, title?: string): void {
    if (msg && typeof msg === 'string' && msg.length > 0) {
      const _title = (title && typeof title === 'string' && title.length > 0) ? title : null;
      this.toastr.error(msg, _title).then();
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/core/toast.service.ts